import * as React from "react";
import {Display} from "../components/Display";
import {UserListFilter} from "./UserListFilter";
import {hasFilters, UserListContext} from "./contexts/UserListContext";
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import {AppTranslations} from "../components/Utils/translations/AppTranslations";
import {ACCESS_DRIVEN_PROCESSES, MANAGE_USERS, userHasPermission} from "../components/Utils/RolesUtils";
import {VeboxUser} from "../providers/VeboxUser";

declare var AppTranslations: AppTranslations;

interface UserListCountProps {
    addNewUser: () => void;
}

export const UserListCount: React.FC<UserListCountProps> = ({addNewUser}) => {

    const {totalUser} = React.useContext(UserListContext)

    const [filterOpen, setFilterOpen] = React.useState<boolean>(false);
    const [isExporting, setIsExporting] = React.useState(false);

    const {rawFilter, stringFilter, filterParams, filterGuid} = React.useContext(UserListContext);

    const loggedInUser = VeboxUser.useCurrentUser();
    const canManageUsers: boolean = React.useMemo(() => userHasPermission(loggedInUser, MANAGE_USERS), [loggedInUser]);
    const canAccessDrivenProcess: boolean = React.useMemo(
        () => userHasPermission(loggedInUser, ACCESS_DRIVEN_PROCESSES),
        [loggedInUser?.guid]);

    const openFilter = () => setFilterOpen(true);

    const closeFilter = () => setFilterOpen(false);

    const startExport = () => {
        if (!isExporting) {
            setIsExporting(true);
            RestDataLoader.downloadSpreadsheetKeepingFileName(`users/report?${filterGuid ? "" : stringFilter}`,
                filterGuid ? {filterGuid} : filterParams,
                () => setIsExporting(false),
                console.error
            );
        }
    }

    return (
        <div className={"user-list-actions"}>
            <Display isVisible={!filterOpen}>
                <span className={"item-count"}>{totalUser ?? 0} {AppTranslations.usersManagement.items}</span>
                <div className={"flx-row flx-space-between gap-10"}>
                    <Display isVisible={canManageUsers && canAccessDrivenProcess}>
                        <div
                            className={"menu-action-button circleButton entityListButton "}
                            style={{position: "relative", width: 57, height: 57, marginTop: 0}}
                            onClick={addNewUser}
                        >
                            <img
                                className="menu-action-button-img"
                                src="images/buttons/person-add.png"
                                style={{width: 25, height: 25, top: 16, left: 16, color: "white"}}
                                alt={"Add user"}
                            />
                        </div>
                    </Display>
                    <div
                        className={"exportToExcelImgDiv"}
                        style={{width: 62, height: 62, display: "inline-block", overflow: "hidden"}}
                        onClick={startExport}
                    >
                        <div
                            id="exportToExcelButton"
                            className={"exportToExcelButton circleButton entityListButton " + (isExporting ? "loading-cursor" : "")}
                            style={{position: "relative", width: 57, height: 57, marginTop: 0}}
                        >
                            <img
                                id="exportToExcelImg" className="exportToExcelImg"
                                src="images/buttons/icon-excelLogo.png"
                                style={{width: 25, height: 25, top: 16, left: 16}}
                                alt={"Export icon"}
                            />
                        </div>
                    </div>
                    <div
                        className={"circleButton circleButtonWhiteBorder circleButtonWhiteBorderBackgroundBlack "}
                        onClick={openFilter}
                    >
                        <div className={"icon iconFilter " + (hasFilters(rawFilter) ? "active " : "")}/>
                    </div>
                </div>
            </Display>
            <Display isVisible={filterOpen}>
                <UserListFilter onClose={closeFilter}/>
            </Display>
        </div>
    );
}